module.exports = require("@swa-ui/bootstrap");